// TODO: also use this in alertItem
let /** @type {?} */ anPositionToAnimationLink: Object = {
  topLeft: 'fadeInLeft',
  topCenter: 'fadeInDown',
  topRight: 'fadeInRight',
  bottomLeft: 'fadeInLeft',
  bottomCenter: 'fadeInUp',
  bottomRight: 'fadeInRight'
};

export default anPositionToAnimationLink;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
